export const aiRoadVideoList = [
  {
    id: 1,
    title: "General System Introduction",
    cover: require("@/assets/images/academy/eiCad_cover_1.png"),
    desc: "Including how to install AIRoad, basic function introduction, etc",
    videoUrl: "",
  },
  {
    id: 2,
    title: "Create 3D Terrain",
    cover: require("@/assets/images/academy/eiCad_cover_2.png"),
    desc: "Including demonstrations of various functions in the AIRoad geographic information module",
    videoUrl: "",
  },
  {
    id: 3,
    title: "Design of Horizontal Alignment",
    cover: require("@/assets/images/academy/eiCad_cover_3.png"),
    desc: "Including the introduction and demonstration of various functions under the road module",
    videoUrl: "",
  },
];

export const eiCadVideoList = [
  {
    id: 11,
    title: "EICAD Full Module Collection",
    cover: require("@/assets/images/academy/eiCad_cover_1.png"),
    desc: "Quick Start and demonstration of all functional modules",
    videoUrl: "",
  },
  {
    id: 12,
    title: "Common Issues In Cross-Sectional Design",
    cover: require("@/assets/images/academy/eiCad_cover_2.png"),
    desc: "Includes EICAD full module collection, interchange design common problem collection, cross-sectional design common problem collection, and …",
    videoUrl: "",
  },
  {
    id: 13,
    title: "Common Problems With Systems And Numerical Models",
    cover: require("@/assets/images/academy/eiCad_cover_3.png"),
    desc: "Includes EICAD full module collection, interchange design common problem collection, cross-sectional design common problem collection, and…",
    videoUrl: "",
  },
];
export const vrRoadVideoList = [
  {
    id: 21,
    title: "Introduction to the Basic Functions of VRRoad Starter",
    cover: require("@/assets/images/academy/vrRoad_cover_1.png"),
    desc: "Introduction to modules including project management, material plaza, data analysis, etc",
    videoUrl: "",
  },
  {
    id: 22,
    title: "Introduction to VRRoad Model Editor",
    cover: require("@/assets/images/academy/vrRoad_cover_2.png"),
    desc: "Introduction to functions such as model property panel, model library, and how to insert models",
    videoUrl: "",
  },
  {
    id: 23,
    title: "Introduction to VRRoad Driving Simulation Data Analysis Function",
    cover: require("@/assets/images/academy/vrRoad_cover_3.png"),
    desc: "Including driving data analysis, data export, data comparison and other functions",
    videoUrl: "",
  },
];
export const report3DVideoList = [
  {
    id: 31,
    title: "Report3D Introduction to Basic Functions",
    cover: require("@/assets/images/academy/report3D_cover_1.png"),
    desc: "Introduction to basic functions such as project creation and importing road models",
    videoUrl: "",
  },
  {
    id: 32,
    title: "Create Region (*. txt) File",
    cover: require("@/assets/images/academy/report3D_cover_2.png"),
    desc: "Create Region (*. txt) file",
    videoUrl: "",
  },
  {
    id: 33,
    title: "Import AIRoad Models",
    cover: require("@/assets/images/academy/report3D_cover_3.png"),
    desc: "How to use AIRoad+Report3D to simulate and report construction plans",
    videoUrl: "",
  },
];
